export default __webpack_public_path__ + "static/media/tick.144ef9af.svg";